import {
  Box,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { LandingGearTypeFilter } from "../../../../types/subAssembly";
import { LANDING_GEAR_TYPE_OPTIONS } from "../../../../utils/subAssemblyUtils";
import { useHasPermission } from "../../../../hooks/useHasPermission";

type Props = {
  filter: LandingGearTypeFilter;
  onChange: (value: LandingGearTypeFilter) => void;
  onCreate: () => void;
};

const FILTER_OPTIONS: LandingGearTypeFilter[] = ["All", ...LANDING_GEAR_TYPE_OPTIONS];

export function SubAssemblyFilterPane({ filter, onChange, onCreate }: Readonly<Props>) {
  const canCreate = useHasPermission("assets-assemblies", "create");

  return (
    <Paper
      sx={{
        width: 250,
        minWidth: 250,
        backgroundColor: "#111",
        border: "1px solid #333",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignSelf: "stretch",
        maxHeight: "100%",
        overflow: "hidden",
      }}
    >
      <Box sx={{ overflowY: "auto", flexGrow: 1, p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, color: "hsl(19 101% 51% / 1)" }}>
          Filter Sub-Assemblies
        </Typography>

        <List disablePadding>
          {FILTER_OPTIONS.map((option) => (
            <ListItem key={option} disablePadding>
              <ListItemButton
                selected={filter === option}
                onClick={() => onChange(option)}
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "hsl(19 101% 51% / 0.2)",
                    "&:hover": {
                      backgroundColor: "hsl(19 101% 51% / 0.3)",
                    },
                  },
                }}
              >
                <ListItemText
                  primary={option}
                  sx={{
                    "& .MuiListItemText-primary": {
                      color: filter === option ? "hsl(19 101% 51% / 1)" : "#fff",
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>

      {canCreate && (
        <Box sx={{ p: 2, pt: 1, flexShrink: 0 }}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onCreate}
            sx={{
              backgroundColor: "hsl(19 101% 51% / 1)",
              "&:hover": {
                backgroundColor: "hsl(19 101% 41% / 1)",
              },
            }}
          >
            Add Sub-Assembly
          </Button>
        </Box>
      )}
    </Paper>
  );
}
